import type { FilterControl, NumberInputControl } from '../../../../../types/filterControl';
import { NoddiInput } from '../../../../Inputs/NoddiInput';
import { useDebouncedFilterInput } from './useDebouncedFilterInput';

export const NumberInputFilter = ({
  control,
  renderFilterTitle
}: {
  control: NumberInputControl;
  renderFilterTitle: (control: FilterControl) => React.ReactNode;
}) => {
  const { localValue, setLocalValue } = useDebouncedFilterInput(
    control.value,
    control.onChange,
    (raw) => (raw === '' ? null : Number(raw)),
    (value) => value?.toString() ?? ''
  );

  return (
    <div className='max-w-35'>
      {renderFilterTitle(control)}
      <NoddiInput
        type='number'
        placeholder={control.placeholder ?? 'Enter a number'}
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        className='min-w-0'
      />
    </div>
  );
};
